import React from 'react';

import { 
	func, 
	object,
	oneOfType,
	string
} from 'prop-types';


export default class Container extends React.PureComponent {
    static propTypes = {
    	render : func.isRequired,
    	onSetTimer : func.isRequired,
    	recipe : object,
    	error : oneOfType([object,string])
    }

    constructor(props){
    	super(props);
    	this.state={
    		enableTimerInput : false,
    	};
    }
	
    render(){
    	const {render, onSetTimer, error, ...other} = this.props;
    	if(error){
    		return render({
    			error
    		},other);
    	}
    	return render({
    		enableTimerInput : this.state.enableTimerInput,
    		onConfirmTimer : (recipe)=>(time)=>{
    			if((typeof time)==='number'){
    				onSetTimer&&onSetTimer(time,recipe);
    				this.setState({enableTimerInput:false});
    			}
    		},
    		onCancelTimer : () => {
    			this.setState({enableTimerInput:false});
    		},
    		onToggleTimerInput : (enable)=>()=>{
    			this.setState({enableTimerInput:enable});
    		},
    	},other);
    }
}